// extracted by mini-css-extract-plugin
module.exports = {"container":"OldBrowserStub_container_u4PEq","title":"OldBrowserStub_title_wgt7k"};